<template>
  <div>
    <base-header class="header pb-5 pt-5 pt-lg-8 d-flex align-items-center" type="gradient-live"></base-header>

    <div class="container-fluid mt--6" :class="{loading:entrando}">
         <div class="col-12">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">Alterar Senha</h3>
                </div>
              </div>
            </div>
            <base-alert :type="alerta.tipo" v-if="alerta.aberto" :class="{shake: alerta.shake}">
                <span class="alert-inner--icon mr-2">
                <i :class="alerta.icone"></i>
                </span>
                <span class="alert-inner--text">{{alerta.mensagem}}</span>
            </base-alert>
            <template>
              <form @submit="salvar()" enctype="multipart/form-data">
                <div class="col-xl-5">
                    <base-input
                    class="orm-control-alternative"
                    placeholder="Senha"
                    addon-left-icon="ni ni-lock-circle-open"
                    v-model="password.v"
                    :error="password.msg"
                    name="email"
                    @keypress.enter="salvar()"
                    ></base-input>
                </div>

                <div class="col-xl-5">
                    <base-input
                    class="orm-control-alternative"
                    placeholder="Confirme a senha"
                    addon-left-icon="ni ni-lock-circle-open"
                    v-model="password2.v"
                    :error="password2.msg"
                    name="email"
                    @keypress.enter="salvar()"
                    ></base-input>
                </div>
              </form>
            </template>
            <div slot="footer" class="row pr-2">
              <base-button type="primary" class="ml-auto" @click="salvar()">Salvar</base-button>
            </div>
          </card>
        </div>
    </div>
  </div>
</template>

<script>
import usuario from "@/cflow/usuario.js";
import storage from "storage";
//import router from '@/router'

export default {
  data() {
    return {
      password: { v: "", msg: ""},
      password2: { v: "", msg: ""},
      entrando: false,
      teste: false,
       alerta: {
        aberto: false,
        shake: false,
        tipo: "",
        mensagem: "",
        icone: "",
      },
      logged_user:{
        nome: storage.get("user", "nome"),
        id: storage.get("user", "id")
      }
    };
  },
  methods: {
    salvar: function () {
      var app = this;
      app.teste = true;

        this.entrando = true
        usuario
            .changePassword(this.logged_user.id, this.password.v, this.password2.v)
            .then((isValid) => {
            // Se retornou o token então logou:
            if (isValid) {
                app.form = {
                    one: false,
                    two: true,
                    three: false
                }
                app.alerta = {
                    aberto: true,
                    tipo: "success",
                    mensagem: "Senha alterada com sucesso!",
                    icone: "fas fa-check-circle",
                    shake: true
                };
                app.password.v = '';
                app.password2.v = '';
            }
            })
            .catch((error) => {
            if (error.response.data.errors) {
                // Se retornar uma array de erros, botar as mensagens em seus devidos campos.
                Object.entries(error.response.data.errors).forEach(
                ([key, value]) => {
                    if (key in app) app[key].msg = value[0];
                }
                );
            }
            // Se retornar uma mensagem de erro:
            if (error.response.data.error) {
                app.password.msg = '';
                app.password2.msg = '';
                app.alerta = {
                    aberto: true,
                    tipo: "danger",
                    mensagem: error.response.data.error,
                    icone: "fas fa-exclamation-triangle",
                    shake: true
                };
            }
            }).finally(() => {
            this.entrando = false
            })
        }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.definicao .form-group{
  transition: 0.2s;
}
.definicao.inativo .form-group{
  opacity: 0.5;
}
.definicao .remover{
  height: 43px;
  margin-top: 31px;
}
.definicao .status{
  margin-top: 41px;
}

</style>
